import React from "react";
import { useReveal } from "./useReveal";

function Education() {
  const reveal = useReveal();

  return (
    <section id="education" className={`section ${reveal.className}`} ref={reveal.ref}>
      <div className="shell">
        <p className="eyebrow">Background</p>
        <h2>Education</h2>
        <div className="edu-grid">
          <div>
            <h3>Texas A&amp;M University</h3>
            <p>B.S. Electrical Engineering, Minor in Mathematics</p>
            <p className="meta">December 2024 · College Station, TX</p>
          </div>
          <div>
            <h3>Certification</h3>
            <p>IPC Certified Interconnect Designer (CID)</p>
            <p className="meta">February 2026</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Education;
